import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App.js'
import React               from 'react';
import ReactDOM            from 'react-dom';

ReactDOM.render(
	<App /> , document.getElementById('root')
);